/** The key a feeder's id is minted under: "DV·zul". */
export const FEEDER_KEY = "zul";

/** What Karl suggests for a feeder until he confirms one; a feeder is sized by load, which no plan shows. */
export const FEEDER_CABLE_SUGGESTION = "NYM-J 5x10";

/** Ink, not a run's hue: a feeder is a different thing from a circuit. */
export const FEEDER_RGB: [number, number, number] = [30, 41, 59];
